module.exports = __webpack_public_path__ + "static/media/sensorvector.fba65ec7.svg";